import { useContext } from "react";

import type { ClientContextData } from "./provider";
import { ClientContext } from "./provider";

export const useClientContext = (): ClientContextData => {
  const context = useContext(ClientContext);

  if (!context) {
    throw new Error(
      "useClientContext must be used within the context, check your ClientContext provider",
    );
  }

  return context;
};
